import { Component, OnInit, TemplateRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs/operators';
import { DesktopDrawerService } from './desktop-drawer-service';

@UntilDestroy()
@Component({
  selector: 'yat-desktop-drawer-dialog',
  templateUrl: './desktop-drawer-dialog.component.html',
  styleUrls: ['./desktop-drawer-dialog.component.scss']
})
export class DesktopDrawerDialogComponent implements OnInit {
  isOpen = false;
  contentTemplate: TemplateRef<any> | null = null;

  constructor(private readonly drawerService: DesktopDrawerService) {}

  ngOnInit(): void {
    this.drawerService.isOpen$
      .pipe(
        tap(isOpen => (this.isOpen = isOpen)),
        untilDestroyed(this)
      )
      .subscribe();

    this.drawerService.content$
      .pipe(
        tap(content => (this.contentTemplate = content)),
        untilDestroyed(this)
      )
      .subscribe();
  }

  onClose(): void {
    this.drawerService.closeDrawer();
  }

  onKeyPress = (event: KeyboardEvent): void => {
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.onClose();
    }
  };
}
